"use client";

import { Link, useNavigate } from "react-router-dom";
import WestBreeze from "../assets/WestBreeze.png";
import loginImage from "../assets/loginImage.png";
import Celebrate from "../assets/Celebrate.png";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRegisterUserMutation } from "../services/Api";
import { toast } from "react-toastify";
import { useState } from "react";
import signIn from "../assets/signIn.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Select from "react-select";
import { countryOptions } from "../pages/adminPanel/pages/addPackingList/utils";
import { banner_traveller, login_img } from "../assets/updated_assests/assets";

const Signup = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, "First name must be at least 2 characters")
      .max(50, "First name cannot exceed 50 characters")
      .required("First name is required"),
    lastName: Yup.string()
      .min(2, "Last name must be at least 2 characters")
      .max(50, "Last name cannot exceed 50 characters")
      .required("Last name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter a valid email"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/^[^\s]+$/, "Password must not contain spaces"),
    confirmPassword: Yup.string()
      .required("Please confirm your password")
      .oneOf([Yup.ref("password")], "Passwords do not match"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(
        /^\+?[1-9]\d{7,14}$/,
        "Please enter a valid phone number with country code (e.g. +123456789)"
      ),
    gender: Yup.string()
      .required("Gender is required")
      .oneOf(["MALE", "FEMALE", "OTHER"], "Please select a valid gender"),
    dateOfBirth: Yup.date()
      .max(new Date(), "Date of birth cannot be in the future")
      .required("Date of birth is required"),
    nationality: Yup.string().required("Nationality is required"),
    termsAndConditions: Yup.boolean()
      .oneOf([true], "You must accept the terms and conditions")
      .required("You must accept the terms and conditions"),
    newsletter: Yup.boolean(),
  });

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues: {
      newsletter: false,
      nationality: [],
    },
  });

  const [registerUser, { isLoading: registerUserLoading }] =
    useRegisterUserMutation();

  const onSubmit = (values) => {
    console.log("data in clg", values);

    const data = {
      email: values?.email,
      password: values?.password,
      firstName: values?.firstName,
      lastName: values?.lastName,
      nationality: values?.nationality,
      phoneNumber: values?.phoneNumber,
      gender: values?.gender,
      dateOfBirth: values?.dateOfBirth,
      termsAndConditions: values?.termsAndConditions,
      newsletter: values?.newsletter,
    };

    registerUser({ data: data })
      .unwrap()
      .then((payload) => {
        if (payload.success) {
          navigate("/login");
          toast.success("Sign Up Successfully");
        } else {
          toast.error(payload?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.data?.message);
      });
  };

  // Custom styles for react-select
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "2px solid #1a1a1a",
      borderRadius: "6px",
      minHeight: "48px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#1a1a1a",
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#D9DCB0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#1a1a1a",
      fontFamily: "'Quicksand', sans-serif",
      fontWeight: "500",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#1a1a1a",
      ":hover": {
        backgroundColor: "#ff9f5a",
        color: "white",
      },
    }),
    menu: (provided) => ({
      ...provided,
      border: "2px solid #1a1a1a",
      borderRadius: "6px",
      boxShadow: "none",
    }),
  };

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {/* Navigation bar with green-yellow background */}
      <div className="w-full bg-[#D9DCB0] p-4 md:p-5">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <Link to="/" className="text-[#ff6b35]">
            <img
              src={WestBreeze || "/placeholder.svg"}
              alt="Westbreeze"
              className="w-[160px]"
            />
          </Link>
          <Link
            to="/login"
            className="bg-transparent border-2  border-[#1a1a1a] px-4 py-3 flex items-center gap-2"
          >
            <span className="text-sm font-bold font-['Quicksand'] flex items-center ">
              <img
                src={signIn || "/placeholder.svg"}
                className="w-6 h-6 mr-2 transition-all filter "
              />
              Sign In
            </span>
          </Link>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col md:flex-row overflow-hidden">
        {/* Left side - Image */}
        <div className="hidden md:block w-full md:w-2/5">
          <img
            src={banner_traveller || "/placeholder.svg"}
            alt="Adventure"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Right side - Signup form */}
        <div className="w-full md:w-3/5 bg-[#ECE8CE] flex items-start p-8 md:p-24 pt-12 overflow-auto">
          <div className="w-full max-w-xl">
            <div className="mb-8">
              <h2 className="font-['Roboto_Mono'] font-bold italic text-xl mb-2">
                Sign Up To Westbreeze
              </h2>
              <p className="font-['Quicksand'] font-medium text-sm text-gray-600">
                Unite with passionate travelers, earn perks on your adventures,
                and unlock.
              </p>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                  <label className="block font-['Quicksand'] font-medium text-xs mb-2">
                    Name *
                  </label>
                  <input
                    type="text"
                    {...register("firstName")}
                    className="w-full px-4 py-3 bg-transparent border-2 border-[#1a1a1a] rounded-md focus:outline-none font-['Quicksand'] font-medium text-sm text-black placeholder-gray-500"
                    placeholder="First name"
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.firstName.message}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block font-['Quicksand'] font-medium text-xs mb-2">
                    Last name *
                  </label>
                  <input
                    type="text"
                    {...register("lastName")}
                    className="w-full px-4 py-3 bg-transparent border-2 border-[#1a1a1a] rounded-md focus:outline-none font-['Quicksand'] font-medium text-sm text-black placeholder-gray-500"
                    placeholder="Last name"
                  />
                  {errors.lastName && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.lastName.message}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label className="block font-['Quicksand'] font-medium text-xs mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  {...register("email")}
                  className="w-full px-4 py-3 bg-transparent border-2 border-[#1a1a1a] rounded-md focus:outline-none font-['Quicksand'] font-medium text-sm text-black placeholder-gray-500"
                  placeholder="email@example.com"
                />
                {errors.email && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.email.message}
                  </p>
                )}
              </div>

              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="block font-['Quicksand'] font-medium text-xs">
                    Password *
                  </label>
                  <Link
                    to="/forgot-password"
                    className="text-[#1a1a1a] font-['Quicksand'] font-medium text-xs hover:underline"
                  >
                    Forgot password?
                  </Link>
                </div>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    {...register("password")}
                    className="w-full px-4 py-3 bg-transparent border-2 border-[#1a1a1a] rounded-md focus:outline-none pr-10 font-['Quicksand'] font-medium text-sm text-black placeholder-gray-500"
                    placeholder="password"
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-gray-800"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <FaEyeSlash className="h-5 w-5" />
                    ) : (
                      <FaEye className="h-5 w-5" />
                    )}
                  </button>
                </div>
                {errors.password && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.password.message}
                  </p>
                )}
              </div>

              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="block font-['Quicksand'] font-medium text-xs">
                    Confirm password *
                  </label>
                  <Link
                    to="/forgot-password"
                    className="text-[#1a1a1a] font-['Quicksand'] font-medium text-xs hover:underline"
                  >
                    Forgot password?
                  </Link>
                </div>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    {...register("confirmPassword")}
                    className="w-full px-4 py-3 bg-transparent border-2 border-[#1a1a1a] rounded-md focus:outline-none pr-10 font-['Quicksand'] font-medium text-sm text-black placeholder-gray-500"
                    placeholder="confirm password"
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-gray-800"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <FaEyeSlash className="h-5 w-5" />
                    ) : (
                      <FaEye className="h-5 w-5" />
                    )}
                  </button>
                </div>
                {errors.confirmPassword && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.confirmPassword.message}
                  </p>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                  <label className="block font-['Quicksand'] font-medium text-xs mb-2">
                    Phone number *
                  </label>
                  <input
                    type="text"
                    {...register("phoneNumber")}
                    className="w-full px-4 py-3 bg-transparent border-2 border-[#1a1a1a] rounded-md focus:outline-none font-['Quicksand'] font-medium text-sm text-black placeholder-gray-500"
                    placeholder="Phone number"
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.phoneNumber.message}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block font-['Quicksand'] font-medium text-xs mb-2">
                    Gender *
                  </label>
                  <select
                    {...register("gender")}
                    className="w-full px-4 py-3 bg-transparent border-2 border-[#1a1a1a] rounded-md focus:outline-none font-['Quicksand'] font-medium text-sm text-black placeholder-gray-500"
                  >
                    <option value="">Select Gender</option>
                    <option value="MALE">Male</option>
                    <option value="FEMALE">Female</option>
                    <option value="OTHER">Other</option>
                  </select>
                  {errors.gender && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.gender.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                  <label className="block font-['Quicksand'] font-medium text-xs mb-2">
                    Date of birth *
                  </label>
                  <input
                    type="date"
                    {...register("dateOfBirth")}
                    className="w-full px-4 py-3 bg-transparent border-2 border-[#1a1a1a] rounded-md focus:outline-none font-['Quicksand'] font-medium text-sm text-black"
                    max={new Date().toISOString().split("T")[0]}
                  />
                  {errors.dateOfBirth && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.dateOfBirth.message}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block font-['Quicksand'] font-medium text-xs mb-2">
                    Nationality *
                  </label>
                  <Select
                    options={countryOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={customStyles}
                    onChange={(selected) => {
                      setValue("nationality", selected ? selected.value : "");
                    }}
                    placeholder="Select nationality..."
                  />
                  {errors.nationality && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.nationality.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-8 mt-4">
                {/* Terms and Conditions checkbox */}
                <div className="flex items-center gap-2">
                  <div className="relative flex items-center cursor-pointer">
                    <input
                      id="termsAndConditions"
                      type="checkbox"
                      {...register("termsAndConditions")}
                      className="hidden"
                    />
                    <label
                      htmlFor="termsAndConditions"
                      className="flex items-center cursor-pointer"
                    >
                      <div className="w-7 h-7 bg-white rounded-md flex items-center justify-center mr-2">
                        <div
                          className={`w-5 h-5 rounded-md ${watch("termsAndConditions")
                            ? "bg-[#ff9f5a] flex items-center justify-center"
                            : "bg-[#ff9f5a]"
                            }`}
                        >
                          {watch("termsAndConditions") && (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5 12L10 17L19 8"
                                stroke="white"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                      <span className="font-['Quicksand'] font-medium text-sm">
                        Terms and Conditions *
                      </span>
                    </label>
                  </div>
                  {errors.termsAndConditions && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.termsAndConditions.message}
                    </p>
                  )}
                </div>

                {/* Newsletter checkbox */}
                <div className="flex items-center gap-2">
                  <div className="relative flex items-center cursor-pointer">
                    <input
                      id="newsletter"
                      type="checkbox"
                      {...register("newsletter")}
                      className="hidden"
                    />
                    <label
                      htmlFor="newsletter"
                      className="flex items-center cursor-pointer"
                    >
                      <div className="w-7 h-7 bg-white rounded-md flex items-center justify-center mr-2">
                        <div
                          className={`w-5 h-5 rounded-md ${watch("newsletter")
                            ? "bg-[#D9DCB0] flex items-center justify-center"
                            : "bg-[#D9DCB0]"
                            }`}
                        >
                          {watch("newsletter") && (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5 12L10 17L19 8"
                                stroke="white"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                      <span className="font-['Quicksand'] font-medium text-sm">
                        Newsletter *
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-14">
                <button
                  type="submit"
                  className="inline-flex items-center font-['Quicksand'] font-bold justify-center px-3 py-3 bg-white border-2 border-[#1a1a1a] hover:bg-[#d4d8a8] hover:text-black transition-colors"
                  disabled={registerUserLoading}
                >
                  {registerUserLoading ? (
                    <svg
                      className="animate-spin h-5 w-5 mr-2"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        fill="none"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  ) : (
                    <img
                      src={Celebrate || "/placeholder.svg"}
                      alt="Celebrate"
                      className="h-6 w-6 mr-2"
                    />
                  )}
                  Create Profile
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
